// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.handler.RpcDispatcher
import org.multipaz.rpc.handler.RpcNotifier
import org.multipaz.rpc.handler.RpcReturnCode
import org.multipaz.cbor.Bstr
import org.multipaz.wallet.shared.WalletBackend
import org.multipaz.rpc.client.RpcStub
import org.multipaz.cbor.buildCborArray
import kotlinx.io.bytestring.ByteString
import org.multipaz.wallet.shared.ClientType
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItem
import org.multipaz.wallet.shared.GoogleTokens
import org.multipaz.cbor.Simple
import org.multipaz.wallet.shared.Session
import org.multipaz.wallet.shared.GetSharedDataResult
import org.multipaz.wallet.shared.WalletClientPublicData
import org.multipaz.wallet.shared.CredentialIssuer
import org.multipaz.securearea.KeyAttestation
import org.multipaz.crypto.X509CertChain
import org.multipaz.wallet.shared.CreateVerificationLinkResult
import org.multipaz.cbor.Cbor
import org.multipaz.wallet.shared.fromDataItem
import org.multipaz.securearea.toDataItem
import org.multipaz.wallet.shared.CreateVerificationLinkResult_fromDataItem


class WalletBackendStub(
    endpoint: String,
    dispatcher: RpcDispatcher,
    notifier: RpcNotifier,
    state: DataItem = Bstr(byteArrayOf())
): RpcStub(endpoint, dispatcher, notifier, state), WalletBackend {

    override suspend fun getNonce(): String {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getNonce", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asTstr
    }

    override suspend fun signIn(nonce: String, googleIdTokenString: String, walletServerEncryptionKeySha256: ByteString, resetSharedData: Boolean, initialSharedData: ByteString, clientType: ClientType) {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(nonce))
            add(Tstr(googleIdTokenString))
            add(Bstr(walletServerEncryptionKeySha256.toByteArray()))
            add(resetSharedData.toDataItem())
            add(Bstr(initialSharedData.toByteArray()))
            add(Tstr(clientType.name))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "signIn", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
    }

    override suspend fun signInWithGoogleCode(nonce: String, authorizationCode: String, redirectUri: String, walletServerEncryptionKeySha256: ByteString, resetSharedData: Boolean, initialSharedData: ByteString, clientType: ClientType): String {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(nonce))
            add(Tstr(authorizationCode))
            add(Tstr(redirectUri))
            add(Bstr(walletServerEncryptionKeySha256.toByteArray()))
            add(resetSharedData.toDataItem())
            add(Bstr(initialSharedData.toByteArray()))
            add(Tstr(clientType.name))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "signInWithGoogleCode", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asTstr
    }

    override suspend fun exchangeCodeForTokens(nonce: String, authorizationCode: String, redirectUri: String): GoogleTokens {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(nonce))
            add(Tstr(authorizationCode))
            add(Tstr(redirectUri))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "exchangeCodeForTokens", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return GoogleTokens.fromDataItem(rpcResponse[3])
    }

    override suspend fun getClientId(): String {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getClientId", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asTstr
    }

    override suspend fun signOut() {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "signOut", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
    }

    override suspend fun markAlive(clientDevice: String?, clientPlatform: String?) {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(clientDevice?.let { Tstr(it) } ?: Simple.NULL)
            add(clientPlatform?.let { Tstr(it) } ?: Simple.NULL)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "markAlive", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
    }

    override suspend fun getSessions(lang: String?): List<Session> {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(lang?.let { Tstr(it) } ?: Simple.NULL)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getSessions", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        val array = rpcResponse[3].let {
            buildList<Session> {
                for (value in it.asArray) {
                    add(Session.fromDataItem(value))
                }
            }
        }
        return array
    }

    override suspend fun signOutSession(clientId: String) {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(clientId))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "signOutSession", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
    }

    override suspend fun getSharedData(currentVersion: Long): GetSharedDataResult? {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(currentVersion.toDataItem())
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getSharedData", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return if (rpcResponse[3] == Simple.NULL) { null } else { GetSharedDataResult.fromDataItem(rpcResponse[3]) }
    }

    override suspend fun putSharedData(data: ByteString): Long {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Bstr(data.toByteArray()))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "putSharedData", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asNumber
    }

    override suspend fun getPublicData(currentVersion: Long?): WalletClientPublicData? {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(currentVersion?.toDataItem() ?: Simple.NULL)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getPublicData", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return if (rpcResponse[3] == Simple.NULL) { null } else { WalletClientPublicData.fromDataItem(rpcResponse[3]) }
    }

    override suspend fun getCredentialIssuers(): List<CredentialIssuer> {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getCredentialIssuers", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        val array0 = rpcResponse[3].let {
            buildList<CredentialIssuer> {
                for (value in it.asArray) {
                    add(CredentialIssuer.fromDataItem(value))
                }
            }
        }
        return array0
    }

    override suspend fun getEula(locale: String): String {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(locale))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getEula", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asTstr
    }

    override suspend fun certifyReaderKeys(readerKeys: List<KeyAttestation>): List<X509CertChain> {
        val array1 = readerKeys.let {
            buildCborArray {
                for (value in it) {
                    add(value.toDataItem())
                }
            }
        }
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(array1)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "certifyReaderKeys", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        val array2 = rpcResponse[3].let {
            buildList<X509CertChain> {
                for (value in it.asArray) {
                    add(X509CertChain.fromDataItem(value))
                }
            }
        }
        return array2
    }

    override suspend fun createVerificationLink(encryptedVerificationPayload: ByteString, expirationDurationAfterCreatedSeconds: Long?): CreateVerificationLinkResult {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Bstr(encryptedVerificationPayload.toByteArray()))
            add(expirationDurationAfterCreatedSeconds?.toDataItem() ?: Simple.NULL)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "createVerificationLink", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return CreateVerificationLinkResult_fromDataItem(rpcResponse[3])
    }

    override suspend fun getVerificationLinkOrigin(): String {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getVerificationLinkOrigin", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return rpcResponse[3].asTstr
    }

    override suspend fun getVerificationPayload(requestId: String): ByteString {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(requestId))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getVerificationPayload", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return ByteString(rpcResponse[3].asBstr)
    }

    override suspend fun submitVerificationResponse(requestId: String, encryptedResponse: ByteString) {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(requestId))
            add(Bstr(encryptedResponse.toByteArray()))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "submitVerificationResponse", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
    }

    override suspend fun deleteVerificationRequest(requestId: String) {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(requestId))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "deleteVerificationRequest", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
    }

    override suspend fun deleteVerificationResponse(requestId: String) {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(requestId))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "deleteVerificationResponse", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
    }

    override suspend fun getVerificationResponse(requestId: String): ByteString? {
        val rpcState = this.rpcState
        val rpcParameters = buildCborArray {
            add(rpcState)
            add(Tstr(requestId))
        }
        val rpcResponse = rpcDispatcher.dispatch(rpcEndpoint, "getVerificationResponse", rpcParameters)
        this.rpcState = rpcResponse[0]
        if (rpcResponse[2].asNumber.toInt() != RpcReturnCode.RESULT.ordinal) {
            this.rpcDispatcher.exceptionMap.handleExceptionReturn(rpcResponse)
        }
        return if (rpcResponse[3] == Simple.NULL) { null } else { rpcResponse[3].let { ByteString(it.asBstr) } }
    }

    companion object {
        fun fromDataItem(
            data: DataItem,
            dispatcher: RpcDispatcher,
            notifier: RpcNotifier,
        ): WalletBackendStub {
            val endpoint = data["endpoint"].asTstr
            val state = data["state"]
            return WalletBackendStub(endpoint, dispatcher, notifier, state)
        }

        fun fromCbor(
            data: ByteArray,
            dispatcher: RpcDispatcher,
            notifier: RpcNotifier,
        ): WalletBackendStub {
            val dataItem = Cbor.decode(data)
            return fromDataItem(dataItem, dispatcher, notifier)
        }
    }
}
